module.exports = __webpack_public_path__ + "img/菜刀.b1b249c0.png";